/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'basic/no-drink-1218401': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M19.71 16.29l-14-14a1 1 0 00-1.42 1.42L6.59 6H5a1 1 0 00-.9.57 1 1 0 00.12 1L11 16.1V20H6.75a1 1 0 000 2h10.5a1 1 0 000-2H13v-3.9l1.64-2 3.65 3.65a1 1 0 001.42 0 1 1 0 000-1.46zM7.08 8h1.51l1.89 1.89H8.59zM12 14.15l-1.81-2.26h2.29l.74.74zM14.66 8h2.26l-.63.79a1 1 0 00.15 1.4 1 1 0 00.63.22 1 1 0 00.78-.37l1.93-2.42a1 1 0 00.12-1A1 1 0 0019 6h-4.34a1 1 0 000 2z"/>'
  }
})
